import styled from "styled-components";

export const Cont = styled.div`
   
  

   #loading, #loading2, #aguarde, #btn-envia-formulario-loading{
    display: none
   }

   input[type="file"] {
    width: 90%;
}
   
   .small, small {
        font-size: 12px;
        font-weight: 400;
        display: block;
    }
    .uk-list>*>ul, .uk-list>:nth-child(n+2){
        margin-top: 0!important;
   }

   .ImgProfissional {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    background: #043c5a;
    img {
      width: 100%;
      object-fit: cover;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
   }
   
  

        @media only screen and  (max-width: 1366px) {

  
        }

        @media only screen and  (max-width: 1024px) {


        }
        @media only screen and  (max-width: 801px) {
            

        }

        @media only screen and  (max-width: 480px) {

        
        }

        @media only screen and  (max-width: 480px) {
        
        }


`;

export const HomeCss = styled.div`

 



`; 